import { api } from '../../helpers/Api';
import Cart from './Cart';
var CartStore = /** @class */ (function () {
    function CartStore() {
    }
    CartStore.prototype.read = function (id) {
        if (id)
            return api.get('carttokens' + id);
        return api.get('carttokens').then(function (value) {
            return value;
        });
    };
    CartStore.prototype.readToFrom = function (_a) {
        var from = _a.from, to = _a.to;
        var eagers = '[cartTickets]';
        var url = "carttokens?eager=".concat(eagers, "&cartTokens.created_at=").concat(from, ",").concat(to, "&select=cartTokens.id,cartTokens.created_at,token,paid_at,contact");
        return api.get(url).then(function (value) {
            return value.map(function (cart) { return new Cart(cart); });
        });
    };
    return CartStore;
}());
export default CartStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Carts/CartStore.ts
// module id = 749
// module chunks = 0